<template>
  <div>
    <div v-if="weekends && weekends.length > 0">
      <md-card>
        <md-card-header>
          <div class="md-title">Weekends</div>
        </md-card-header>

        <md-card-content>
          <md-table>

            <md-table-row v-if="weekends && weekends.length > 0">
              <md-table-head md-sort-name="name">Name</md-table-head>
              <md-table-head>Courses</md-table-head>
              <md-table-head>Start Date</md-table-head>
              <md-table-head>End Date</md-table-head>
            </md-table-row>

            <md-table-row v-for="object in weekends" :key="object.versionedId.id" >
              <md-table-cell>{{object.name}}</md-table-cell>
              <md-table-cell>{{lookupCourseName(object.courseIds)}}</md-table-cell>

              <md-table-cell>{{object.start}}</md-table-cell>
              <md-table-cell>{{object.end}}</md-table-cell>

              <md-table-cell>
                <md-button class="md-icon-button md-dense md-primary editButton" :to="'weekend/' + object.versionedId.id" >
                  <md-icon>today</md-icon>
                </md-button>
                <md-button class="md-icon-button md-dense md-primary editButton"
                           :to="'weekendReports/' + object.versionedId.id">
                  <md-icon>link</md-icon>
                </md-button>
                <span>
                  <md-icon style="margin-top: 4px;" v-if="!object.edit && isSoftLocked(object.versionedId.id)" class="md-morph-final"><md-tooltip md-direction="bottom">{{getLockedByString(object.versionedId.id)}}</md-tooltip>warning</md-icon>
                </span>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
        <md-card-actions>
          <md-button class="md-primary md-raised" to="new">New Weekend</md-button>
        </md-card-actions>
      </md-card>
    </div>
    <div v-if="!weekends || weekends.length <= 0">
      <md-empty-state
        md-icon="folder_special"
        md-label="Create your first weekend"
        md-description="There aren't any weekends yet.">
        <md-button class="md-primary md-raised" to="new">Create weekend</md-button>
      </md-empty-state>
    </div>
  </div>


</template>

<script>
  export default {
    name: "all-weekends",
    data() {
      return {
        newWeekend: {
          courseId: '',
          start: null,
          end: null,
          sections: null,
          studentsPerSection: null
        },
        weekendCopy: {
          weekendId: '',
          startDate: null
        },
        saving: false
      }
    },
    computed: {
      weekends() {
        if (this.$store.state.currentCityDetails && this.$store.state.currentCityDetails.weekends) {
          return this.$store.state.currentCityDetails.weekends;
        } else {
          return [];
        }
      }
    },
    methods: {
      isSoftLocked(lockId) {
        return (this.$store.state.otherUserPageLocks[lockId] !== undefined)
      },
      getLockedByString(lockId) {
        if (this.$store.state.otherUserPageLocks[lockId] !== undefined) {
          return Object.keys(this.$store.state.otherUserPageLocks[lockId]).join(', ');
        } else {
          return "";
        }
      },
      showNewObjectDialog() {
        this.mutableFields.forEach(fieldName => {
          this.newObject[fieldName] = '';
        });
        this.createPromptActive = true;
      },
      lookupCourseName(ids) {
        if (!ids || !this.$store.state.currentCityDetails)
          return '';

        var courseNames = [];
        this.$store.state.currentCityDetails.courses.forEach(course => {
          ids.forEach(id => {
            if (course.versionedId.id === id.id)
              courseNames.push(course.name);
          });
        });
        return courseNames.join(", ");
      }
    }
  }
</script>

<style scoped>
  .dialogContent {
    padding: 24px;
  }

  .md-table-head {
    text-align: center;
  }

  button.editButton { visibility: hidden;}
  tr:hover button.editButton{ visibility: visible;}

</style>



// WEBPACK FOOTER //
// src/components/city/weekend/AllWeekends.vue